import { TRUST_ITEMS } from "../../data/content";
import { Reveal } from "./Reveal";

export const TrustStrip = () => (
    <section data-testid="trust-strip" className="py-14 lg:py-16">
        <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                {TRUST_ITEMS.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.06}>
                        <div className="group flex flex-col items-center gap-3 rounded-2xl border border-white/8 bg-[#0D131F]/70 px-4 py-6 text-center transition-all duration-300 hover:border-[#00E5FF]/40 hover:bg-[#131C2E]">
                            <item.icon
                                size={22}
                                className="text-[#00E5FF] transition-transform duration-300 group-hover:scale-110"
                            />
                            <span className="text-xs sm:text-sm font-medium text-slate-300">
                                {item.title}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
